import cx from "classnames";

import { Cross, Magnify } from "components/icons/generated";
import { SEARCH_PLACEHOLDERS } from "constants/searchPlaceholders";
import ButtonIcon from "ds/components/ButtonIcon";
import Input from "ds/components/Input";
import LoadingIndicator from "ds/components/LoadingIndicator";

import styles from "./styles.module.css";
import { AutocompleteProps } from "./types";
import useAutocomplete from "./useAutocomplete";
import Icon from "../Icon";

const LOADING_MINIMUM_DURATION = 200;

const Autocomplete = (props: AutocompleteProps) => {
  const {
    query,
    onChange,
    className,
    placeholder = SEARCH_PLACEHOLDERS.DEFAULT,
    onEnterKey,
    loading,
  } = props;

  const { handleOnChange, handleOnKeyDown, clearQuery } = useAutocomplete({
    onChange,
    onEnterKey,
  });

  return (
    <div className={cx(styles.autocompleteWrapper, className)}>
      <LoadingIndicator
        loading={loading}
        minimumDuration={LOADING_MINIMUM_DURATION}
        className={styles.loadingIndicator}
      >
        <Icon className={styles.magnifier} src={Magnify} />
      </LoadingIndicator>

      <Input
        value={query}
        onChange={handleOnChange}
        placeholder={placeholder}
        onKeyDown={handleOnKeyDown}
      />
      {query.length > 0 && (
        <ButtonIcon className={styles.clear} variant="ghost" icon={Cross} onPress={clearQuery}>
          Clear
        </ButtonIcon>
      )}
    </div>
  );
};

Autocomplete.displayName = "DS.Autocomplete";

export default Autocomplete;
